module.exports = __webpack_public_path__ + "static/media/status-R.bfc95510.svg";